//components/SavedListings.jsx

import React from "react";
import {
  Box,
  Typography,
  List,
  ListItem,
  ListItemAvatar,
  Avatar,
  IconButton,
  Button,
  Divider,
  Skeleton,
} from "@mui/material";
import { Delete, ArrowForwardIos } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

const SavedListings = ({ savedListings, loading }) => {
  const navigate = useNavigate();

  const handleListingClick = (id) => {
    navigate(`/listing/${id}`);
  };

  return (
    <Box sx={{ mt: 4, px: 3, maxWidth: "900px", mx: "auto" }}>
      <Typography variant="h4" sx={{ fontWeight: "bold", mb: 3, textAlign: "center" }}>
        Your Saved Listings
      </Typography>

      {loading ? (
        <List>
          {[...Array(3)].map((_, index) => (
            <ListItem key={index} sx={{ py: 2 }}>
              <Skeleton variant="rectangular" width="100%" height={80} sx={{ borderRadius: 2 }} />
            </ListItem>
          ))}
        </List>
      ) : savedListings.length === 0 ? (
        <Typography color="textSecondary" sx={{ textAlign: "center", fontSize: "1.2rem" }}>
          No saved listings found.
        </Typography>
      ) : (
        <List>
          {savedListings.map(({ id, title, imageUrl }) => (
            <React.Fragment key={id}>
              <ListItem
                sx={{
                  p: 2,
                  borderRadius: 2,
                  background: "#fff",
                  boxShadow: "0px 2px 6px rgba(0,0,0,0.1)",
                  transition: "0.2s ease-in-out",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  "&:hover": {
                    background: "#f5f5f5",
                    boxShadow: "0px 4px 12px rgba(0,0,0,0.15)",
                  },
                }}
              >
                {/* ✅ Listing Details (Left Side) */}
                <Box sx={{ flex: 1, display: "flex", flexDirection: "column" }}>
                  <Typography variant="h6" sx={{ fontWeight: "bold", mb: 0.5 }}>
                    {title}
                  </Typography>
                  <Typography variant="body2" color="textSecondary">
                    Listing ID: {id}
                  </Typography>
                </Box>

                {/* ✅ Buttons (Middle) */}
                <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                  <Button
                    variant="contained"
                    color="primary"
                    size="small"
                    endIcon={<ArrowForwardIos />}
                    onClick={() => handleListingClick(id)}
                    sx={{ borderRadius: 2, px: 3 }}
                  >
                    View
                  </Button>
                  <IconButton
                    color="error"
                    onClick={(e) => {
                      e.stopPropagation();
                      console.warn("Implement favorite removal here");
                    }}
                  >
                    <Delete />
                  </IconButton>
                </Box>

                {/* ✅ Thumbnail Image (Right Side) */}
                <ListItemAvatar>
                  <Avatar
                    variant="rounded"
                    src={imageUrl || "/placeholder.jpg"}
                    alt={title}
                    sx={{ width: 70, height: 70, borderRadius: 2 }}
                  />
                </ListItemAvatar>
              </ListItem>

              <Divider sx={{ my: 1 }} />
            </React.Fragment>
          ))}
        </List>
      )}
    </Box>
  );
};

export default SavedListings;
